import {
    CustomerRegistrationErrorResponse,
    CustomerRegistrationRequest,
    CustomerRegistrationResponse,
} from '~/pages/api/customer/create';

export const useCreateCustomer = () => {
    const createCustomer = async (
        customerData: CustomerRegistrationRequest
    ): Promise<CustomerRegistrationResponse | CustomerRegistrationErrorResponse> => {
        const result = await fetch('/api/customer/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(customerData),
        });

        const { status } = result;
        const data = await result.json();

        if (status !== 201) {
            return {
                httpStatus: status,
                message: data.message,
            };
        }

        return {
            ...data,
        };
    };

    return { createCustomer };
};
